import React, { useState } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import RestUtilities from '../../services/RestUtilities';

import {
  Grid,
  TextField,
  Button,
  Box,
  LinearProgress,
  Typography,
} from '@mui/material';
import InlineError from '../../components/Common/InlineError';
import { useSetRecoilState } from 'recoil';
import { userState } from '../../state/RecoilState';

const SignInSide: React.FC = () => {
  const navigate = useNavigate();
  const setUser = useSetRecoilState(userState);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [feedback, setFeedback] = useState<string | null>('');
  const [errors, setErrors] = useState(null);
  const isPasswordInvalid = !!(password.length < 5 || password.length > 30);
  const isUsernameInvalid = !!(username.length < 5 || username.length > 32);
  const hasErrors = isUsernameInvalid || isPasswordInvalid;

  async function handleLoginClick(e: any) {
    e.preventDefault();
    setDisabled(true);
    const url = '/api/auth/login';
    const data = { password, username };
    var response = await RestUtilities.post(url, data);
    if (response.ok) {
      setUser(response.content.user);
      navigate('/');
    } else if (response.status === 400) {
      setFeedback('There were errors:');
      setErrors(response.errorContent);
      setDisabled(false);
    } else if (response.status === 401) {
      setFeedback('The username and password combination was not recognised.');
      setDisabled(false);
      setErrors(null);
    }
  }

  return (
    <>
      <Typography component='h1' variant='h5'>
        Login
      </Typography>
      <form noValidate>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              variant='outlined'
              value={username}
              margin='normal'
              required
              fullWidth
              id='username'
              label={'Username'}
              name='username'
              autoComplete='username'
              autoFocus
              onChange={(event) => {
                setUsername(event.target.value);
                setFeedback(null);
              }}
              disabled={disabled}
              error={isUsernameInvalid && !!username}
              helperText={
                isUsernameInvalid &&
                !!username &&
                'Must be minimum 5 characters and maximum of 16'
              }
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              variant='outlined'
              value={password}
              margin='normal'
              required
              fullWidth
              name='password'
              label={'Password'}
              type='password'
              id='password'
              autoComplete='current-password'
              onChange={(event) => {
                setPassword(event.target.value);
                setFeedback(null);
              }}
              error={!!password && isPasswordInvalid}
              helperText={
                !!password &&
                isPasswordInvalid &&
                'Must be minimum 5 characters and maximum of 30'
              }
              disabled={disabled}
            />
          </Grid>
        </Grid>
        <Button
          type='submit'
          fullWidth
          variant='contained'
          color='secondary'
          onClick={(e) => handleLoginClick(e)}
          disabled={disabled || hasErrors}
        >
          Sign In
        </Button>
        {disabled && (
          <Box m={2}>
            <LinearProgress color='secondary' />
          </Box>
        )}
        {feedback && (
          <Grid container>
            <Grid item xs={12}>
              <Typography component='p'>{feedback}</Typography>
              <InlineError field='username' errors={errors} />
              <InlineError field='password' errors={errors} />
            </Grid>
          </Grid>
        )}
        <Box mt={5}>
          <Grid container>
            <Grid item xs>
              <Link to={'/forgotpassword'}>Forgot password?</Link>
            </Grid>
          </Grid>
        </Box>
      </form>
    </>
  );
};

export default SignInSide;
